import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, of } from "rxjs";
import { environment } from "src/index";
import { FaqItem } from "src/index";

@Injectable({
  providedIn: "root",
})
export class FaqService {
  private httpClient = inject(HttpClient);
  supportEmail = "";

  getFaqs() {
    if (environment.faqs) {
      return this.httpClient
        .get<FaqItem[]>(environment.faqs)
        .pipe(catchError(() => of([] as FaqItem[])));
    }
    return of([] as FaqItem[]);
  }
}
